module.exports = __webpack_public_path__ + "static/img/shadowPlay.6700186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/shadowPlay.png
// module id = C38F
// module chunks = 26